const contribute = [
    {
        "key": "contribute.greeting",
        "string": "Hello {variable}, here is an overview of your content."
    },
    {
        "key": "contribute.logout",
        "string": "Logout"
    }
]

export default contribute



// WEBPACK FOOTER //
// ./src/i18n/en/contribute/_contribute.js